import { render, staticRenderFns } from "./form-skeleton.vue?vue&type=template&id=0637e9ee&"
import script from "./form-skeleton.vue?vue&type=script&lang=js&"
export * from "./form-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./form-skeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports